import { mapGetters, mapState } from "vuex";
import get from "lodash/get";

export default {
  computed: {
    ...mapState(["setup"]),
    ...mapGetters(["isPortal"]),
    ...mapGetters("portal", ["activeContent"]),
    activeContentHeader() {
      if (!this.isPortal || !this.activeContent) return null;

      const content = this.activeContent;

      return {
        name: content.name,
        description: content.description,
        cover: content.cover || content.background || content.logo || null,
        cover_mobile: null,
        picture_mobile: null,
        cover_view_type: null,
        cover_view_type_mobile: null,
        link_video: null,
        link_video_mobile: null
      };
    },
    headerConfig() {
      const setup = this.setup || {};

      return this.activeContentHeader
        ? { ...setup, ...this.activeContentHeader }
        : setup;
    },
    headerDescription() {
      return get(this.headerConfig, "description") || "";
    }
  }
};
